import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import perksNearMe from "@irati/ui/images/perks-near-me.svg"
import {Body, H3} from "@irati/ui/src/Typography"

import {Container, ImageTextWrapper, StyledButtonRouterLink, Image} from "./styled/SearchAllByLocationCTA"

class SearchAllByLocationCTA extends PureComponent {
  static propTypes = {
    searchTerm: PropTypes.string,
    className: PropTypes.string,
    onButtonClick: PropTypes.func
  }

  static defaultProps = {
    searchTerm: "",
    className: null,
    onButtonClick: () => {}
  }

  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  render() {
    const {searchTerm, className, onButtonClick} = this.props
    const {apps} = this.context

    const params = searchTerm ? `?q=${searchTerm}` : ""
    const routerLinkUrl = `/perks/location${params}`

    return (
      <Container className={className}>
        <ImageTextWrapper>
          <Image src={perksNearMe} />
          <div>
            <H3 paddingBottom={0.5}>
              <FormattedMessage id="search.components.searchAllByLocationCTA.heading" />
            </H3>
            <Body small overflow="hidden">
              <FormattedMessage id="search.components.searchAllByLocationCTA.para" />
            </Body>
          </div>
        </ImageTextWrapper>
        <StyledButtonRouterLink to={routerLinkUrl} primary full app={apps.SEARCH} onClick={onButtonClick}>
          <FormattedMessage id="search.components.searchAllByLocationCTA.button.text" />
        </StyledButtonRouterLink>
      </Container>
    )
  }
}

export default injectIntl(SearchAllByLocationCTA)
